// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

h4 {
    /* font-size: 14px; */
    /* font-weight: 600; */
    color: #111;
    margin-top: 0px;
    margin-bottom: 12px;
}

p {
    /* font-size: 14px; */
    color: #111;
    margin-top: 0;
    margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./code/styles/fonts.css"],"names":[],"mappings":";;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB","sourcesContent":["\n\nh4 {\n    /* font-size: 14px; */\n    /* font-weight: 600; */\n    color: #111;\n    margin-top: 0px;\n    margin-bottom: 12px;\n}\n\np {\n    /* font-size: 14px; */\n    color: #111;\n    margin-top: 0;\n    margin-bottom: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
